module.exports = __webpack_public_path__ + "img/vs.aaa624f4.jpg";